'use strict';

angular.module('atex.dam').controller('DamVersionsController', [
      '$scope', '$rootScope', '$state', '$stateParams',
      '$filter', '$sce', '$timeout', '$q',
      'ContentService', 'DamService', 'DamNotificationService', 'DamCompareModal',
      'DamTemplateService', 'configuration',
function($scope, $rootScope, $state, $stateParams,
         $filter, $sce, $timeout, $q,
         ContentService, DamService, DamNotificationService, DamCompareModal,
         DamTemplateService, configuration) {
  
  var currentLineHeightThumbList = 120;
  $scope.entries  = [];
  $scope.selected  = [];
  $scope.querying = true;

  $scope.id = $stateParams.id; 
  
  $scope.modified = undefined;
  $scope.compareConfig = undefined;
  $scope.usePrintServer = false;

  $scope.back = function() {
    if ($scope.modified) {
      // Notify the list
      $timeout(function() {
        $rootScope.$broadcast('dam:updatedItem', $scope.modified);
      });
    }
    $state.go('list');
  };

  $scope.clearSelection = function() {
    $scope.selected.length = 0;
  };

  function findUserById(users, userId) {
    var user = _.find(users, function(obj) {
      return obj.principalId === userId;
    });
    return user;
  }

  var collectVersions = function(versions) {
    $scope.querying = true;
    var versionsPromises = versions.map(function(item) {
      return ContentService.getContent({ id: item.version }).then(function(responseInfo) {
        atex.dam.AngularUtils.fixUrls(responseInfo.data);
        // attach to the item a temp versionInfo
        responseInfo.versionInfo = item;
        DamService.getUsers().then(function(users) {
          var user = findUserById(users, item.creatorId);
          responseInfo.versionInfo.creatorName = (user && user.name) ? user.name : item.creatorId;
        });
        return responseInfo;
      }).then(null, function(error) {
        if (!error.rootCause || error.rootCause.status!==403) {
          console.log('ERROR: Getting content:', error);
        }
        return undefined;
      });
    });
    return $q.all(versionsPromises).then(function(results) {
      return results;
    });
  };

  var loadContentHistory = function(id) {
    $scope.entries = [];
    $scope.selected  = [];
    ContentService.getContentHistory({id : $scope.id}).then(function (responseData) {
      collectVersions(responseData.data.versions).then(function(list) {
        list = _.filter(list, function(_entry) {
          return (typeof _entry !== "undefined");
        });
        list.reverse().forEach(function(entry, index) {
          if (typeof entry !== 'undefined') {
            if (index === 0) {
              // Mark the first in the entries list as current
              entry.versionInfo.current = true;
            }
            entry._data = entry.data;
            delete entry.data;
          }
        });
        $scope.entries = list;
        $scope.selected  = [];
        $scope.selected.push($scope.entries[0]);
        $scope.querying = false;

        loadCompareConfig( $scope.id, $scope.entries[0] );
      }).then(null, function(error) {
        console.log('Error while loading versions list!', error);
        $scope.querying = false;
      });
    }, function (error) {
      console.log('ERROR: getContentHistory error:', error);
      $scope.querying = false;
    });
  };

  loadContentHistory($scope.id);

  var loadCompareConfig = function( contentId, entry ) {
    var templateId = entry._data.aspects.contentData.data._type;
    templateId += ".dam.preview";
    var inputTemplate = entry._data.aspects.contentData.data.inputTemplate;
    DamTemplateService.getTemplateByIdAndInputTemplate(templateId, inputTemplate).then(function(template){
      $scope.onecmsTemplate = template;

      var compare = _.extend( {binding: "channels", usePrintServer: false}, template.compare);

      $scope.usePrintServer = compare.usePrintServer;

      $scope.compareConfig = _.find(template.dataBindings, function(binding) {
        return binding.name === compare.binding;
      });
    }).then(null, function(error) {
      //$scope.showSpinner = false;
      console.log('ERROR: loadVersion:', error);
    });
  };

  $scope.canMakeCurrent = function() {
    if ($scope.selected.length===1 && !angular.equals($scope.selected[0], $scope.entries[0])) {
      return true;
    }
    return false;
  };

  $scope.makeCurrent = function() {
    if ($scope.canMakeCurrent()) {
      var item = angular.copy($scope.selected[0]);
      item.revision = $scope.entries[0].revision;
      atex.dam.AngularUtils.sanitizeContentData(item._data.aspects.contentData);
      delete(item._data.lockData);
      ContentService.updateContent({
        id: item.id,
        revision: item.revision,
        data: item._data
      }).then(function(response) {
        $scope.modified = item;
        loadContentHistory($scope.id);
      }).then(null, function(error) {
        $scope.saving = false;
        var message = error.cause;
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
      });
    }
  };

  $scope.canCompare = function() {
    if ($scope.compareConfig && $scope.selected.length>0) {
      return true;
    }

    return false;
  };

  $scope.showJson = function() {
    ContentService.getContent({ id: $scope.selected[0].versionInfo.version}).then(function(responseInfo) {
      if ($scope.selected.length === 1) {
        var library = {};

        library.json = {
          replacer: function(match, pIndent, pKey, pVal, pEnd) {
            var key = '<span class=json-key>';
            var val = '<span class=json-value>';
            var str = '<span class=json-string>';
            var r = pIndent || '';
            if (pKey){
              r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ';
            }
            if (pVal){
              r = r + (pVal[0] === '"' ? str : val) + pVal + '</span>';
            }
            return r + (pEnd || '');
          },
          prettyPrint: function(obj) {
            var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg;
            return JSON.stringify(obj, null, 3)
              .replace(/&/g, '&amp;').replace(/\\"/g, '&quot;')
              .replace(/</g, '&lt;').replace(/>/g, '&gt;')
              .replace(jsonLine, library.json.replacer);
          }
        };
        var x = window.open();
        x.document.open();
        x.document.write('<style>pre {height: auto;max-height: 1800px;overflow: auto;background-color: #eeeeee;word-break: normal !important;word-wrap: normal !important;white-space: pre !important;}');
        x.document.write('.json-key {color: brown;}.json-value {color: navy;}.json-string {color: olive;}</style>');
        x.document.write('<html><body><pre>' + library.json.prettyPrint(removeTypeProp(responseInfo.data)) + '</pre></body></html>');
        x.document.close();
      }else if ($scope.selected.length === 2){
        ContentService.getContent({ id: $scope.selected[1].versionInfo.version}).then(function(responseInfo2) {
          compareJson(removeTypeProp(responseInfo.data.aspects),removeTypeProp(responseInfo2.data.aspects));
        });
      }else if($scope.selected.length > 2){
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: "Max 2 items"}), true);
      }
    });
  };

  function removeTypeProp(obj) {
    for (var property in obj) {
      if (typeof obj[property] === "object" && !(property.endsWith("_type") || property.endsWith("_types"))) {
        delete obj.property;
        var newJsonData= removeTypeProp(obj[property]);
        obj[property]= newJsonData;
      } else {
        if ((property.endsWith("_type") || property.endsWith("_types"))) {
          delete obj[property];
        }
      }
    }
    return obj;
  }

  var compareJson = function(leftRev, rightRev) {
    if (configuration.getJsonAspectsToCompare()){
      Object.keys(leftRev).forEach(function(aspect){
        if (!configuration.getJsonAspectsToCompare().includes(aspect)){
          delete leftRev[aspect];
        }
      });
      Object.keys(rightRev).forEach(function(aspect){
        if (!configuration.getJsonAspectsToCompare().includes(aspect)){
          delete rightRev[aspect];
        }
      });
    }
    $rootScope.leftRev = leftRev;
    $rootScope.rightRev = rightRev;
    $rootScope.idSelectedVersion = $scope.selected[0].id;
    $state.go('list.jsoncompare');
  };

  $scope.compare = function() {
    if ($scope.canCompare()) {
      if ($scope.selected.length === 1){
        if ($scope.entries[0] !== $scope.selected[0]){
          $scope.selected.push($scope.entries[0]);
        }else{
          $scope.selected.push($scope.entries[1]);
        }
      }
      var onMakeCurrent = function( update, item, message ) {
        if ( update ) {
          $scope.modified = item;
          loadContentHistory($scope.id);
        }

        if ( !update && message && message !== '' ) {
          $scope.saving = false;
          DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);
        }
      };

      var compareOptions = {
        entries:  $scope.entries,
        selected:  $scope.selected,
        contentId: $scope.id,
        compareBinding: $scope.compareConfig,
        usePrintServer: $scope.usePrintServer,

        onMakeCurrent: onMakeCurrent
      };

      var compareModal = DamCompareModal.showCompare( compareOptions );
    }

  };



}]);

